import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import Input from "../../../ui/input";
import Button from "../../../button-v1";
import toast from "react-hot-toast";
import { Checkbox } from "../../../ui/checkbox";
import { deviceTypes } from "../../../../utils/constants";
import Cart from "./items";

import { getDeviceTypes, createBulkOrder } from "../../../../services/devices";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

// COMPONENTS
import EmailView from "./email";

const OrderBulk = ({
  addType,
  setAddType,
  devices,
  setDevices,
  handleEmail,
}) => {
  const queryClient = useQueryClient();
  const [email, setEmail] = useState(null);

  const [device, setDevice] = useState({
    device_type: "",
    quantity: "",
    name: "",
  });

  // queries
  const deviceTypesQuery = useQuery(["device-types"], () => getDeviceTypes());

  const handleInsert = () => {
    if (!device.device_type || !device.quantity || !device.name) return;

    const itemIndex = devices.findIndex(
      (_device) => _device.device_type == device.device_type
    );
    if (itemIndex !== -1) {
      return toast.error("Item already in list");
    }

    console.log("item index", itemIndex);

    setDevices((prev) => [...prev, device]);
    setDevice({
      device_type: "",
      quantity: "",
      name: "",
    });
  };

  const removeDevice = (device_type) => {
    setDevices((prev) =>
      prev.filter((_device) => _device.device_type !== device_type)
    );
  };

  const deviceTypeHandler = (deviceType) => {
    setDevice((prev) => ({
      ...prev,
      device_type: deviceType.id,
      name: deviceType.name,
    }));
  };

  const handleEmailData = (emailData) => {
    setEmail(emailData);
    handleEmail(emailData);
  };

  if (addType === 3) {
    return <EmailView devices={devices} handleEmail={handleEmailData} />;
  }
  if (addType === 2) {
    return (
      <section className={styles.rootContainer}>
        <section className={styles.container}>
          <h3>Order Details</h3>
          <section className={styles.orderInfoContainer}>
            <section className={styles.inputField}>
              <label className={styles.label}>Device Type</label>
              <main className={styles.deviceTypeContainer}>
                {deviceTypesQuery?.data?.map((_deviceType) => (
                  <section className={styles.deviceTypeCheckbox}>
                    <Checkbox
                      className={styles.checkbox}
                      size="large"
                      value={_deviceType.id}
                      checked={device.device_type === _deviceType.id}
                      onCheckedChange={() => deviceTypeHandler(_deviceType)}
                    />
                    <label className={styles.checkboxLabel}>
                      {_deviceType.name}
                    </label>
                  </section>
                ))}
              </main>
            </section>
            <Input
              type="number"
              className="no-arrows"
              placeholder="number of devices"
              label="Quantity"
              name="quantity"
              value={device.quantity}
              onChange={(e) =>
                setDevice((prev) => ({
                  ...prev,
                  quantity: e.target.value,
                }))
              }
            />

            <section className={styles.actionContainer}>
              <Button onClick={() => handleInsert()}>Add Item</Button>
            </section>
          </section>
        </section>
        <Cart
          key={device.device_type}
          devices={devices}
          remove={removeDevice}
        />
      </section>
    );
  }
  return null;
};

export default OrderBulk;
